import { render, staticRenderFns } from "./DetailOfferProject.vue?vue&type=template&id=6ebdaff0&scoped=true"
import script from "./DetailOfferProject.vue?vue&type=script&lang=js"
export * from "./DetailOfferProject.vue?vue&type=script&lang=js"
import style0 from "./DetailOfferProject.vue?vue&type=style&index=0&id=6ebdaff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebdaff0",
  null
  
)

export default component.exports